import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Grid, Button, TextField, CircularProgress } from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const BundleStatus = () => {
  const [msisdn, setMsisdn] = useState("");
  const [data, setData] = useState<any[]>([]);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [action, setAction] = useState<Boolean>(false);

  const columnDefs: ColDef[] = [
    {
      field: "Msisdn",
      headerName: "Msisdn",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "BundleName",
      headerName: "BundleName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "TotalAmount",
      headerName: "TotalRefundedAmount",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "ActivationDate",
      headerName: "ActivationDate",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "TimeStamp",
      headerName: "CancellationDate",
      filter: true,
      sortable: true,
      resizable: true,
    },
  ];
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  const handleGetBundles = async () => {
    setData([]);
    toast.dismiss();
    if (msisdn.trim().length > 9) {
      setAction(true);
      getBundleStatus();
    } else {
      toast.error("Please enter valid input.");
    }
  };
  const formatTimestamp = (timestamp: string) => {
    if (!timestamp) return "";

    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${year}-${month}-${day} ${hours
      .toString()
      .padStart(2, "0")}:${minutes}${ampm}`;
  };

  const getBundleStatus = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/CancelAndRenewalStatus?Msisdn=${msisdn.trim()}`)
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (!apiresponse.Data || apiresponse.Data.length == 0) {
          toast.error("Record not found.");
          setData([]);
        } else {
          const formattedData = apiresponse.Data?.map((item: any) => ({
            ...item,
            TimeStamp: formatTimestamp(item.CancellationDate),
            ActivationDate: formatTimestamp(item.PlanActivationDate),
          }));
          setData(formattedData);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Bundle Refund & Cancellation Status</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="Msisdn"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>

            <Grid item xs={4}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      {data?.length > 0 && (
        <div style={{ height: 540, width: "100%", marginTop: 16 }}>
          <div className="ag-theme-alpine">
            <AgGridReact
              ref={agGridRef}
              paginationPageSize={10}
              pagination={true}
              domLayout="autoHeight"
              rowData={data}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              enableCellTextSelection={true}
            ></AgGridReact>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default BundleStatus;
